import React from 'react';
import PropTypes from 'prop-types';

export default class ImageResizer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
    };

    this.fallback = null;
    this.resizeImage = this.resizeImage.bind(this);
  }

  resizeImage() {
    const target = this.theImage;
    let originalWidth;
    let originalHeight;
    if (!target) {
      return;
    }
    if (!target.naturalWidth && !target.naturalHeight) {
      target.src = this.fallback;
      // svg fallback images don't have a size, so fake it
      originalHeight = 200;
      originalWidth = 400;
    } else {
      originalWidth = target.naturalWidth || 0;
      originalHeight = target.naturalHeight || 0;
    }
    const widthRatio = this.props.width / originalWidth;
    const heightRatio = this.props.height / originalHeight;
    if (widthRatio < heightRatio) {
      this.setState({
        width: originalWidth * widthRatio,
        height: originalHeight * widthRatio,
      });
    } else {
      this.setState({
        width: originalWidth * heightRatio,
        height: originalHeight * heightRatio,
      });
    }
  }

  render() {
    const { image } = this.props;
    this.fallback = image.fallback;
    const style = {
      wrapper: {
        minHeight: '200px',
        minWidth: '400px',
      },
      image: {
        width: this.state.width,
        height: this.state.height,
      },
    };
    return (
      <div className="image-wrapper" style={style.wrapper}>
        <img
          ref={img => { this.theImage = img; }}
          src={image.filename.trim()}
          alt={image.description}
          style={style.image}
          onLoad={this.resizeImage}
          onError={this.resizeImage}
        />
      </div>
    );
  }
}

ImageResizer.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  image: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/ImageResizer/ImageResizer.js